var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "#F32D2D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.80078 10.1992H9.40078H22.2008",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6004 10.2V21.4C20.6004 21.8243 20.4318 22.2313 20.1318 22.5314C19.8317 22.8314 19.4247 23 19.0004 23H11.0004C10.576 23 10.1691 22.8314 9.86902 22.5314C9.56896 22.2313 9.40039 21.8243 9.40039 21.4V10.2M11.8004 10.2V8.6C11.8004 8.17565 11.969 7.76869 12.269 7.46863C12.5691 7.16857 12.976 7 13.4004 7H16.6004C17.0247 7 17.4317 7.16857 17.7318 7.46863C18.0318 7.76869 18.2004 8.17565 18.2004 8.6V10.2",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4004 14.1992V18.9992",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6016 14.1992V18.9992",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.7e57da881e82d4622deba00646ff0d7f.svg";
export { ForwardRef as ReactComponent };